import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createSquareNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

// Custom GCP "Subnet" icon. The official Google Cloud icon set has no
// dedicated subnet glyph (only VPC — see Confluence `Cloud native
// icons`), so this is a codebase-original drawing kept in the GCP
// visual language: dashed boundary in `#4285F4` (Google Blue) with
// three host dots in `#669DF6` connected by `#AECBFA` segments. Echoes
// `azureSubnet` (dashed-boundary + inner hosts) so a mixed-vendor path
// reads as "same construct, different vendor" at a glance.
function createGcpSubnetIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    <rect
      x="6.5" y="9.5" width="27" height="21" rx="3"
      fill="#FFFFFF" stroke="#4285F4" stroke-width="1.6"
      stroke-dasharray="2.5 2"
    />
    <line x1="13.5" y1="20" x2="26.5" y2="20" stroke="#AECBFA" stroke-width="1.4"/>
    <circle cx="13.5" cy="20" r="2.6" fill="#4285F4"/>
    <circle cx="20" cy="20" r="2.6" fill="#669DF6"/>
    <circle cx="26.5" cy="20" r="2.6" fill="#4285F4"/>
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const gcpSubnetIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createGcpSubnetIcon,
);
